module.exports = __webpack_public_path__ + "static/media/about.53dfd264.jpg";